<template lang="pug">
section
  v-card
    v-toolbar(flat color='white')
      h2(class='title') Отделы офиса
      v-spacer
      v-btn(@click='onEdit()' small flat)
        v-icon(left small) add
        | Добавить отдел
    v-divider
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Название') {{ props.item.department_name }}
          td(data-label='Телефон') {{ props.item.phone }}
          td(data-label='Email') {{ props.item.email }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: ['officeId'],

  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Название',
        align: 'left',
        value: 'department_name',
        width: '50%',
        sortable: false
      },
      {
        text: 'Телефон',
        align: 'left',
        value: 'phone',
        width: '25%',
        sortable: false
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
        width: '25%',
        sortable: false
      },
      { text: '', align: 'left', width: '0%', sortable: false }
    ],
    count: 100
  }),

  created() {
    this.fetch()
  },

  methods: {
    async onDelete(id) {
      if (await this.$confirm('Удалить отдел?')) {
        await this.destroy({ id })
        this.fetch()
      }
    },

    onEdit(id) {
      this.$router.push({
        name: 'Admin.Offices.Departments.Edit',
        params: {
          id: this.officeId,
          departmentId: id
        }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: {
            count: this.count,
            office_id: this.officeId
          }
        }
      })
    },

    ...mapActions('admin/offices/departments', ['fetchList', 'destroy'])
  },

  computed: {
    list() {
      return this.byOfficeId(this.officeId)
    },

    ...mapState('admin/offices/departments', ['total']),
    ...mapGetters('admin/offices/departments', ['byOfficeId', 'isLoading'])
  }
}
</script>
